import { render } from "./ChangePinView.vue?vue&type=template&id=e673eb4e"
import script from "./ChangePinView.vue?vue&type=script&lang=js"
export * from "./ChangePinView.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__